import AgreementResource from 'Resources/Agreement';
import RequestBuilder, { comparisonTypes } from 'Resources/RequestBuilder';
import AccessType from 'App/enum/AccessType';
import AppService from 'App/legacy/AppService';

// Only CRM users work with subscriptions, but a licence change can leave a non-CRM user on some.
// One limit-1 request per owner found, so the usual case (no such owner) costs a single request.
const nonCrmSubscriptionOwnerIds = async (accessType: AccessType): Promise<number[]> => {
	let candidateIds = (AppService.getUsers(accessType, false, 'all') ?? [])
		.filter(user => !user.crm)
		.map(({ id }) => id);
	const ownerIds: number[] = [];

	while (candidateIds.length) {
		const rb = new RequestBuilder();
		rb.addFilter({ field: 'user.id' }, comparisonTypes.Equals, candidateIds);
		rb.limit = 1;
		rb.fields = ['user'];
		const { data } = await AgreementResource.find(rb.build());
		const ownerId = data[0]?.user?.id;
		if (!ownerId || !candidateIds.includes(ownerId)) {
			break;
		}
		ownerIds.push(ownerId);
		candidateIds = candidateIds.filter(id => id !== ownerId);
	}

	return ownerIds;
};

export default nonCrmSubscriptionOwnerIds;
